import { useState } from "react";
import { ExternalLink } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

import { portfolioItems } from "@/data/portfolio";

import { useLanguage } from '@/lib/i18n';
import BeatsTeaserCard from "./BeatsTeaserCard";

export default function SelectedWorksTeaser() {
    const { t } = useLanguage();
    const work = portfolioItems[0];
    const [openSpotify, setOpenSpotify] = useState(false);

    return (
        <>
            <section className="py-24 md:py-32 border-t border-white/[0.04]">
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    {/* GRID */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

                        {/* ================= PORTFOLIO ================= */}
                        <div className="font-syne text-3xl md:text-4xl font-bold tracking-tight">
                            <a href="/portfolio" className="underline">{t("hero_title1")}</a>
                            <div className="group relative h-[420px] rounded-2xl overflow-hidden border border-white/[0.06] bg-[#0A0A0A] mt-8">
                                {/* BG COVER */}
                                <img
                                    src={work.cover}
                                    alt={work.title}
                                    className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-50 transition"
                                />

                                {/* GRADIENT */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />

                                {/* CONTENT */}
                                <div className="relative h-full flex flex-col justify-end p-8">


                                    <h3 className="font-syne text-2xl mb-1">
                                        {work.title}
                                    </h3>

                                    <p className="text-white/60 text-sm mb-4">
                                        {Array.isArray(work.artist)
                                            ? work.artist.join(" • ")
                                            : work.artist} - {work.year}

                                    </p>

                                    <button
                                        onClick={() => setOpenSpotify(true)}
                                        className="
                    inline-flex items-center gap-2
                    text-sm
                    text-white/70
                    hover:text-white
                    transition
                  "
                                    >
                                        {t("playlist_open")}
                                        <ExternalLink className="w-4 h-4" />
                                    </button>

                                </div>
                            </div>
                        </div>
                        {/* ================= BEATS ================= */}
                        <div className="font-syne text-3xl md:text-4xl font-bold tracking-tight">
                            <p className="mb-8"><a className="underline" href="/beats">{t("hero_title2")}</a></p>
                            <BeatsTeaserCard />
                        </div>
                    </div>
                </div>
            </section>

            {/* ================= SPOTIFY MODAL ================= */}
            <Dialog open={openSpotify} onOpenChange={setOpenSpotify}>
                <DialogContent className="bg-[#0A0A0A] border-white/[0.08] max-w-xl p-0 overflow-hidden">

                    <iframe
                        src={work.spotifyEmbed}
                        width="100%"
                        height="352"
                        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                        loading="lazy"
                        className="border-0"
                    />
                </DialogContent>
            </Dialog>
        </>
    );
}
